//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import aos from "~/mixins/aos.js";

export default {
  mixins: [aos],
  props: {
    two_items_cta: {
      required: false,
    },
  },
};
